import { QueryKey, UseQueryResult, useQuery } from 'react-query';
import { GetInstances } from '@pimm/services/lib/store-equipment/services';

export type GetInstancesParams = {
  siteId?: string;
  equipmentId?: string;
};

export const useGetInstances = (
  query?: GetInstancesParams,
  queryKey?: string,
): UseQueryResult<Awaited<ReturnType<typeof GetInstances>>> => {
  const instances = useQuery({
    enabled: !!query?.siteId,
    queryKey: [queryKey ?? 'GetInstances', query],
    queryFn: async () => {
      const params = query as GetInstancesParams;
      const result = await GetInstances(
        params.siteId!,
        {
          EquipmentId: params.equipmentId,
        },
        { timeout: 1.5 * 60 * 1000 },
      );
      return result;
    },
  });
  return instances;
};
